<template>
  <div class="internationalLookup grid-y">
    <div class="breadcrumb margin-bottom-xs">
      <BreadcrumbWrapper :current-page="currentPage" />
    </div>
    <div id="internationalOrder-lookup">
      <h2 id="title" class="margin-bottom-xs">
        {{ ORDER_LOOKUP.internationalLookup.title }}
      </h2>
      <p>{{ ORDER_LOOKUP.internationalLookup.message }}</p>
      <div id="bfTTContainer" ref="bfTTContainerRef"></div>
      <div v-if="showSkeleton" id="international-lookup-skeleton" class="grid-x">
        <div v-for="index in 2" :key="index" class="cell small-12 medium-7 margin-right-xxs margin-top-xs">
          <Skeleton class="skeleton-item" />
        </div>
        <div class="cell small-8 medium-5 margin-right-xxs margin-top-xs">
          <Skeleton class="skeleton-item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import Skeleton from '@atomic-ui/skeleton/Skeleton';
import { useScriptTag } from '@vueuse/core';
import BreadcrumbWrapper from '@/components/common/BreadcrumbWrapper';
import { ORDER_LOOKUP } from 'config';

const envPropsStore = useEnvPropsStore();
const currentPage = ref('International Lookup');
const envProps = computed(() => envPropsStore.envProps);
const bfTTContainerRef = ref(null);
const showSkeleton = ref(true);
const checkFormLoaded = () => {
  const container = bfTTContainerRef.value;
  if (container?.childNodes.length === 0) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target === container && mutation.addedNodes.length > 0) {
          showSkeleton.value = false;
          observer.disconnect();
        }
      });
    });
    observer.observe(container, { childList: true });
  }
};
onMounted(async () => {
  if (envProps.value.borderFreeScriptUrl) {
    const { load } = useScriptTag(envProps.value.borderFreeScriptUrl, () => {
      console.log('Recaptcha loaded');
    });
    await load();
  }
  checkFormLoaded();
});

onBeforeUnmount(() => {
  const el = document.querySelector(`script[src="${envProps.value.borderFreeScriptUrl}"]`);
  if (el) el.remove();
});
</script>

<style lang="scss" scoped>
.skeleton-item {
  height: 45px;
}
</style>
